<template>
  <!-- Conditional BaseDrawer wrapper -->
  <BaseDrawer
    v-if="!noDrawer"
    no-padding
    height-auto-only
    no-bottom-rounding
    no-toolbar
    close-label="insights"
    class="scrollbar-hide"
    :mobile-view="mobileView"
    :is-child-drawer="isChildDrawer"
    @close="handleClose"
  >
    <template #content>
      <AdInsightsContent
        v-bind="$props"
        @updateTableResults="$emit('updateTableResults', $event)"
        @refetch-insights="$emit('refetch-insights', $event)"
        @updateAds="$emit('updateAds', $event)"
        @update:tableViewTags="$emit('update:tableViewTags', $event)"
        @cycleAd="$emit('cycleAd', $event)"
      />
    </template>
  </BaseDrawer>

  <!-- Direct content without drawer -->
  <div
    v-else
    class="w-full h-full"
  >
    <AdInsightsContent
      v-bind="$props"
      @updateTableResults="$emit('updateTableResults', $event)"
      @refetch-insights="$emit('refetch-insights', $event)"
      @updateAds="$emit('updateAds', $event)"
      @update:tableViewTags="$emit('update:tableViewTags', $event)"
      @cycleAd="$emit('cycleAd', $event)"
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import AdInsightsContent from './AdInsightsContent.vue'

export default {
  name: 'AdInsightsDrawer',
  components: {
    AdInsightsContent,
  },
  props: {
    isAdLevel: {
      type: Boolean,
      default: false
    },
    brand: {
      type: Object,
      default: () => {}
    },
    adDetailsData: {
      type: Object,
      default: () => {}
    },
    selectionIds: {
      type: Object,
      default: () => {}
    },
    adIndex: {
      type: Number,
      default: () => 0
    },
    dataSummary: {
      type: Object,
      default: () => {}
    },
    summaryStats: {
      type: Object,
      default: () => {}
    },
    dateRange: {
      type: Object,
      default: () => {}
    },
    selectedColumns: {
      type: Array,
      default: () => []
    },
    sharedBoard: {
      type: Boolean,
      default: () => false
    },
    sharedBrief: {
      type: Boolean,
      default: () => false
    },
    discovery: {
      type: Boolean,
      default: () => false
    },
    loading: {
      type: Boolean,
      default: () => true
    },
    loadingMetrics: {
      type: Boolean,
      default: () => false
    },
    loadingAdCycle: {
      type: Boolean,
      default: () => false
    },
    adCardSavedId: {
      type: String,
      default: ''
    },
    allAdsLoaded: {
      type: Boolean,
      default: () => false
    },
    withAdCopyExpanded: {
      type: Boolean,
      default: () => false
    },
    isChildDrawer: {
      type: Boolean,
      default: () => false
    },
    noDrawer: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: false
    },
    isPublic: {
      type: Boolean,
      default: false
    },
    isCreativeAggregation: {
      type: Boolean,
      default: false
    },
    uniqueMetricsOverride: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      mobileView: window.innerWidth < 1200
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapMutations('AdvertisementsModule', ['SET_AD_PLAYING']),
    handleClose () {
      this.$emit('close')
      this.SET_AD_PLAYING('')
    },
    handleResize () {
      this.mobileView = window.innerWidth < 1200
    }
  }
}
</script>

<style scoped>

</style>
